import React from "react";
import { Outlet } from "react-router-dom";

import "../../styles/landing-v2.css";

import Navbar from "./Navbar";
import Footer from "./Footer";

/**
 * Shared layout for all marketing/content pages (landing, about, contact, faq,
 * terms, privacy). Navbar, Footer and the design system load ONCE here and stay
 * mounted across route changes — child pages only render their own <main>
 * content via <Outlet>. (Scroll-to-top on navigation is handled globally in
 * app.tsx.)
 */
const MarketingLayout: React.FC = () => {
  return (
    <div className='vp-landing'>
      <Navbar />
      <main id='main-content'>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MarketingLayout;
